import React, { useState } from 'react'
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import FeedBack from './Cards/FeedBack';
import './style/Testimonial.css'

function Testimonial() {
    
    const [X2, setX2]=useState(0);

    const HandleLeft =() => {
        X2!==0? setX2(X2+400) : setX2(-(400*4)) 
    }
    const HandleRight =() => {
        X2!==-(400*4)? setX2(X2-400) : setX2(0)
    }

    return (
        <div className="testimonial">
            <div className="testimonial__header">
                    <span>Testimonial</span>
                    <h2>Client Say Somthing</h2>
            </div>
            <div className="testimonal__client">
                <div className="client" style={{ transform: `translate(${X2}px)`}}>
                    <FeedBack name="Full Name" work="Designer" src="https://images.unsplash.com/photo-1485875437342-9b39470b3d95?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MXwxOTMyNjJ8MHwxfHNlYXJjaHw1fHx3b21lbnxlbnwwfHx8&ixlib=rb-1.2.1&q=80&w=1080"/>
                    <FeedBack name="Full Name" work="Designer" src="https://images.unsplash.com/photo-1499714608240-22fc6ad53fb2?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MXwxOTMyNjJ8MHwxfHNlYXJjaHwzfHxNZW58ZW58MHx8fA&ixlib=rb-1.2.1&q=80&w=1080"/>
                    <FeedBack name="Full Name" work="Designer" src="https://images.unsplash.com/photo-1481214110143-ed630356e1bb?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MXwxOTMyNjJ8MHwxfHNlYXJjaHwyfHx3b21lbnxlbnwwfHx8&ixlib=rb-1.2.1&q=80&w=1080"/>
                    <FeedBack name="Full Name" work="Designer" src="https://images.unsplash.com/photo-1497551060073-4c5ab6435f12?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MXwxOTMyNjJ8MHwxfHNlYXJjaHw2fHxNZW58ZW58MHx8fA&ixlib=rb-1.2.1&q=80&w=1080"/>
                </div>
            </div>
            <div className="client__pagination">
                    <ArrowBackIcon onClick={HandleLeft}/>
                    <ArrowForwardIcon onClick={HandleRight}/>
                </div>
        </div>
    )
}

export default Testimonial
